module.exports = __webpack_public_path__ + "media/assets/icons/reflection-button-41a9074a4d65ef2daeab9f492b0d310a.svg";